import type { AuthProviderProps } from "react-oidc-context";
import type { CognitoConfig } from "../config/config";

/**
 * Build react-oidc-context provider settings for the Cognito Hosted UI using
 * the OAuth2 Authorization Code + PKCE flow. This is a public SPA client, so
 * there is no client secret.
 */
export function buildOidcConfig(cognito: CognitoConfig): AuthProviderProps {
  return {
    authority: cognito.authority,
    client_id: cognito.clientId,
    redirect_uri: cognito.redirectUri,
    response_type: "code",
    scope: cognito.scope,
    automaticSilentRenew: true,
    // After the Hosted UI redirects back, strip ?code/&state from the URL and
    // land on the app root. The /callback route also navigates to "/" via the
    // router once authentication completes.
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, "/");
    },
  };
}
